/* eslint-disable spire/export-styles */
import React, { FC, useEffect } from "react";
import { css } from "styled-components";

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductListDataView } from "@insite/client-framework/Store/Pages/ProductList/ProductListSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { connect } from "react-redux";

const enum fields {
    backgroundColor = "backgroundColor",
    backgroundSize = "backgroundSize",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.backgroundColor]: string;
        [fields.backgroundSize]: "auto" | "cover" | "contain" | "100% 100%";
    };
}

export interface CENBackgroundContainerStyles {
    container?: InjectableCss;
}

const styles: CENBackgroundContainerStyles = {};

export const staticPageContainerStyles = styles;

const mapStateToProps = (state: ApplicationState) => {
    const { productFilters } = state.pages.productList;
    return {
        productFiltersQuery: productFilters.query,
        productsDataView: getProductListDataView(state),
    };
};

type Props = OwnProps & WidgetProps & ReturnType<typeof mapStateToProps>;

const CENPlpBackgroundContainer: FC<Props> = ({ id, fields, productsDataView, productFiltersQuery }) => {
    const products = productsDataView?.value;
    const container = {
        css: css`
            background-color: ${fields.backgroundColor};
            background-size: ${fields.backgroundSize};
            max-width: 1800px;
            margin-right: auto;
            margin-left: auto;
            &.plpBackgroundContainer {
                ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css``,
                    css``,
                    css`
                       margin-top:20px;
                    `,
                    null,
                    null,
                ])}
            }
        `,
    };

    
    return (
        <StyledWrapper
            {...(products?.length === 0 ? "" : container)}
            className="plpBackgroundContainer"
        >
            <Zone contentId={id} zoneName="content" />
        </StyledWrapper>
    );
};

const CENProductListBackgroundContainer: WidgetModule = {
    component: connect(mapStateToProps)(CENPlpBackgroundContainer),
    definition: {
        group: "Common",
        displayName: "CEN Plp Background Container",
        fieldDefinitions: [
            {
                name: fields.backgroundColor,
                editorTemplate: "ColorPickerField",
                displayName: "Color",
                defaultValue: "black",
                fieldType: "General",
            },

            {
                name: fields.backgroundSize,
                displayName: "Background Size",
                editorTemplate: "DropDownField",
                options: [
                    { displayName: "Auto", value: "auto" },
                    { displayName: "Cover", value: "cover" },
                    { displayName: "Contain", value: "contain" },
                    { displayName: "100% 100%", value: "100% 100%" },
                ],
                defaultValue: "auto",
                hideEmptyOption: true,
                fieldType: "General",
            },
        ],
    },
};

export default CENProductListBackgroundContainer;
